import {createFromIconfontCN} from '@ant-design/icons';

//定义项目中使用的图标
const FontIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1893936_i0l5cbjh18.js',
});

export default FontIcon;